import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { DotCMSNavigationItem } from 'dotcms/src/lib/models';

import { DomService } from 'ish-core/utils/dom/dom.service';

import { dotCMSNavigationLink, isIndexPagePresent } from '../../../utils/dot-cms-uve-utils';
import { DotCmsUVEHeaderFolderIndexPageCheckComponent } from '../dot-cms-uve-header-folder-index-page-check/dot-cms-uve-header-folder-index-page-check.component';

@Component({
  selector: 'custom-dot-cms-sub-folder-header-navigation',
  templateUrl: './dot-cms-uve-sub-folder-header-navigation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, CommonModule, DotCmsUVEHeaderFolderIndexPageCheckComponent, FaIconComponent],
})
export class DotCmsUVESubFolderHeaderNavigationComponent {
  readonly subFolderItems = input<DotCMSNavigationItem[]>(undefined);
  readonly depth = input<number>(undefined);
  readonly folderIndex = input<number>(undefined);
  readonly view = input<string>('auto');
  readonly deviceType = input<string>(undefined);

  dotCMSHeaderNavigationLink = dotCMSNavigationLink;
  isHavingIndexPage = isIndexPagePresent;
  openedPages: DotCMSNavigationItem[] = [];

  constructor(private domService: DomService) {}

  isOpened(pages: DotCMSNavigationItem): boolean {
    return this.openedPages.includes(pages);
  }
  toggleOpen(pages: DotCMSNavigationItem) {
    const index = this.openedPages.findIndex(page => page.title === pages.title);
    index > -1 ? this.openedPages.splice(index, 1) : this.openedPages.push(pages);
  }
  hideFlyout(id: number) {
    this.domService.getElementById(`dot-cms-header-flyout${id}`).classList.add('d-none');
  }
}
